/**
 * Normalizes an email address to lowercase and trims whitespace
 * This ensures consistent email handling across the application
 * 
 * @param {string} email - The email address to normalize
 * @returns {string} - The normalized email address (lowercase, trimmed)
 */
export function normalizeEmail(email) {
  if (!email || typeof email !== "string") {
    return email;
  }
  return email.toLowerCase().trim();
}

/**
 * Normalizes email in an object (useful for request bodies)
 * 
 * @param {object} obj - Object that may contain an email field
 * @param {string} fieldName - Name of the email field (default: 'email')
 * @returns {object} - Object with normalized email field
 */
export function normalizeEmailInObject(obj, fieldName = "email") {
  if (!obj || typeof obj !== "object") {
    return obj;
  }
  if (obj[fieldName]) {
    obj[fieldName] = normalizeEmail(obj[fieldName]);
  }
  return obj;
}

